import { defineStore } from "pinia";
import axios from "axios";
import api from "~/config/extensionsApi";

export const useRedirectRouterStore = defineStore("redirectRouter", {
  state: () => ({
    redirects: [],
    isLoaded: false,
  }),
  getters: {
    getRedirects(state) {
      return state.redirects;
    },
  },

  actions: {
    async loadRedirects() {
      if (this.isLoaded) return;
      try {
        const { data } = await axios.get(api.config.config_url_rewrite);
        if (data && data.code === 200) this.redirects = data.result;
        this.isLoaded = true;
      } catch (error) {
        console.error("Error fetching redirects:", error);
      }
    },
  },
});
